import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Viewer } from '@photo-sphere-viewer/core';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import '@photo-sphere-viewer/core/index.css';
import '@photo-sphere-viewer/markers-plugin/index.css';
import { useTranslation } from 'react-i18next';
import { Button, CardContent, Modal } from '@mui/material';
import MainCard from 'components/MainCard';
import { getEquipmentsByZone } from 'components/axios/equipmentAxios';
import { getEquipmentLocationMapByMapId, patchEquipmentLocationMapCoordinates } from 'components/axios/equipmentZoneAxios';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals';
import { markerColorByStatus } from 'data/data';

// const baseUrl = 'https://photo-sphere-viewer-data.netlify.app/assets/';

export function CompanyPanoEquipmentMappingLayer({fileUrl, mapsId, zoneId}) {
  const { t } = useTranslation();

  // modal 관련
  const { openModal } = useModals();
  const handleAlertClick = (alertMessage) => {
      openModal(modals.alertModal, {
          onClose : () => {
              // console.log(1111);
          },
          message: alertMessage,
      });
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  }
  const handleClose = () => setOpen(false);
  
  const [modalOpen, setModalOpen] = useState(false);
  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const markersPluginRef = useRef(null);
  const [markers, setMarkers] = useState([]); // marker infos(id, position)
  const [equipmentMapping, setEquipmentMapping] = useState({}); // equipment-marker mapping infos(markerId, equipmentName)
  const [selectedMarkerId, setSelectedMarkerId] = useState(null); // 선택된 markerId
  const [selectedCoords, setSelectedCoords] = useState(null); //  선택된 position
  const [equipmentList, setEquipmentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [equipmentMappingList, setEquipmentMappingList] = useState(null);

  useEffect(()=> {
    if (open) {
      Promise.all([
        getEquipmentsByZone(zoneId).then((res) => {
          // console.log(res)
          setEquipmentList(res)
        })
      ]).then(()=>{
        setIsLoading(true)
      })
    }
  },[open])

  useEffect(()=>{
    if (open && !isLoading) {
      getEquipmentLocationMapByMapId(mapsId).then((res) => {
        // console.log(res)
        if (res) {
          let mappingList = [];
          let mapping = equipmentMapping;
          res.coordinates?.forEach((m)=> {
            let markerId = `marker-${Math.floor(Math.random() * 10000)}`;
            let newMapping = {
              ...mapping,
              [markerId]: m.equipment.name+'-'+m.equipment.id,
            };
            mapping = newMapping;
            // console.log(newMapping)
            setEquipmentMapping(newMapping);
            mappingList.push({...m, mId : markerId})
          })
          // console.log(mappingList)
          setEquipmentMappingList(mappingList);
        } else {
          setEquipmentMappingList(null)
          setEquipmentMapping({})
        }
      })
    }
  }, [open, isLoading])

  // 컴포넌트 바깥에 변수 선언
  let lastClickTime = 0;

  useLayoutEffect(() => {
    // console.log(1)
    if (!open) return; // DOM 준비되지 않았으면 초기화하지 않음
    const timer = setTimeout(() => {
      if (!containerRef.current) return; // DOM 준비되지 않았으면 초기화하지 않음
      // console.log(2)
      const viewer = new Viewer({
        container: containerRef.current,
        // panorama: `${baseUrl}sphere.jpg`,
        panorama: fileUrl,
        plugins: [
          [MarkersPlugin, {}]
        ],
      });

      viewer.addEventListener('ready', () => {
        // ⚡ 1. 'markers' 문자열 ID로 플러그인 가져오기 (또는 클래스식 재확인)
        const markersPlugin = viewer.getPlugin('markers') || viewer.getPlugin(MarkersPlugin);
        // ⚡ 2. 만약 플러그인을 찾지 못했다면 실행 중단 (에러 방지 핵심)
        if (!markersPlugin) {
          console.warn('MarkersPlugin이 초기화되지 않았습니다.');
          return;
        }
        
        markersPluginRef.current = markersPlugin;

        // 서버에서 저장된 마커 데이터 가져오기
        const markers = equipmentMappingList?.map((m) => {
          return { id: m.mId, equipment: m.equipment, position: { yaw: m.yawOrX, pitch: m.pitchOrY } };
        });
        
        setMarkers(markers || []);
        // console.log(markers)
        markers?.forEach((m) => {
          // console.log(m)
          markersPlugin.addMarker({
            id: m.id,
            position: m.position, // {yaw, pitch}
            image: markerColorByStatus[m.equipment?.status || "unmapped"],
            size: { width: 32, height: 32 },
            anchor: "bottom center",
            tooltip: {
              content : `<div style="width:250px;
                    background: rgba(0,0,0,0.75);
                    padding: 12px 16px;
                    border-radius: 10px;
                    color: #fff;
                    font-size: 14px;
                    display: flex;
                    flex-direction: column;
                    gap: 6px;">${m.equipment ? `${m.equipment.name} (${m.equipment.equipmentNo})` : t('message.common.text.Unmapped')}
                    </div>`,
              position: 'top center',
            }
            // m.equipment ? `${m.equipment.name}` : t('message.common.text.Unmapped'),
          });
        });

        viewer.addEventListener('click', (data) => {
          // console.log(data)
          // console.log(data.data.rightclick)
          console.log(equipmentList.length)
          console.log(equipmentMappingList.length);
          const currentMappingLength = equipmentMappingList?.length || 0;
          if (equipmentList.length <= currentMappingLength) {
            handleAlertClick(t('message.common.alert.all.equipment.mapping.done'))
            return;
          }

          if (data.data.rightclick) return;
          const id = `marker-${Date.now()}`;
          markersPlugin.addMarker({
            id,
            // position: {yaw: data.yaw.toFixed(2), pitch: data.pitch.toFixed(2)},
            position: {yaw: data.data.yaw, pitch: data.data.pitch},
            image: `${markerColorByStatus['unmapped']}`,
            size: { width: 32, height: 32 },
            anchor: 'bottom center',
          });

          setMarkers(prev => [...prev, { id, position: { yaw: data.data.yaw, pitch: data.data.pitch } }]);
          setSelectedMarkerId(id);
          setSelectedCoords({ yaw: data.data.yaw, pitch: data.data.pitch });
        });

        markersPlugin.addEventListener('select-marker', (data, e) => {
          // console.log(data)
          if (data.rightClick) return;
          const now = Date.now();
          if (now - lastClickTime < 300) {
            // 300ms 안에 두 번 클릭 → 더블클릭으로 처리
            handleDeleteMarker(data.marker.config.id);
            setModalOpen(false);
          } else {
            // 싱글클릭 → 기존처럼 모달 열기
            setSelectedMarkerId(data.marker.config.id);
            setSelectedCoords({ yaw: data.marker.config.position.yaw, pitch: data.marker.config.position.pitch });
            setModalOpen(true);
          }
          lastClickTime = now;
        });
      });

      viewerRef.current = viewer;
    }, 0);

    return () => {
      clearTimeout(timer);
      if (viewerRef.current) {
        try {
          viewerRef.current.destroy();
        } catch (e) {
          console.error(e);
        } finally {
          viewerRef.current = null;
          markersPluginRef.current = null; // ⚡ 플러그인 레퍼런스도 함께 초기화
        }
      }
    };
  }, [open, equipmentMappingList]);

  const getAvailableEquipments = () => {
    const used = Object.values(equipmentMapping);
    // console.log(used)
    return equipmentList.filter(e => !used.includes(e.name+'-'+e.id));
  };
  
  // 설비매핑
  const handleMapEquipment = async (equipmentId) => {
    if (!selectedMarkerId) return;
    // console.log(equipmentId)
    const equipment = equipmentList.find(e => e.id == equipmentId);
    // console.log(equipment)
    const image = markerColorByStatus[equipment.status];

    const marker = markers.find(m => m.id === selectedMarkerId);
    // console.log(marker)
    if (!marker) return;
    
    // const newId = selectedValue.split("-").pop(); // "1"
    const usedIds = Object.values(equipmentMapping).map(v => v.split("-").pop());
    // if (equipmentMapping.some(m => m.split("-").pop() == equipmentId)) {
    if (usedIds.includes(equipmentId)) {
      handleAlertClick(t('message.common.alert.already.mapping.equipment.retry.select'))
      return;
    }
  
    if (!markersPluginRef.current) return; // ⚡ 방어 코드 추가
    markersPluginRef.current.updateMarker({
      id: selectedMarkerId,
      image: `${image}`,
    });

    const newMapping = {
      ...equipmentMapping,
      [selectedMarkerId]: equipment.name+'-'+equipmentId,
    };
    setEquipmentMapping(newMapping);

    // 예시 API 호출
    // console.log('POST Marker')
    setModalOpen(false);
  };

  // 매핑해제
  // const handleUnmapEquipment = async () => {
  //   if (!selectedMarkerId) return;

  //   const marker = markers.find(m => m.id === selectedMarkerId);
  //   if (!marker) return;

  //   markersPluginRef.current.updateMarker({
  //     id: selectedMarkerId,
  //     image: `${markerColorByStatus['unmapped']}`,
  //     // position: {yaw: marker.yaw.toFixed(2), pitch: marker.pitch.toFixed(2)},
  //     // size: { width: 32, height: 32 },
  //     // anchor: 'bottom center',
  //   });

  //   const newMapping = { ...equipmentMapping };
  //   delete newMapping[selectedMarkerId];
  //   setEquipmentMapping(newMapping);

  //   // 예시 API 호출
  //   console.log('DELETE Marker')
  //   // await fetch(`/api/unmap-equipment/${selectedMarkerId}`, { method: 'DELETE' });

  //   setModalOpen(false);
  // };

  // 더블클릭으로 마커 삭제
  const handleDeleteMarker = (markerId) => {
    if (!markerId) return;
    // console.log(markerId)
    // 플러그인에서 제거
    markersPluginRef.current.removeMarker(markerId);
    
    // 상태에서 제거
    setMarkers(prev => prev.filter(m => m.id !== markerId));
    
    // 매핑정보 제거
    const newMapping = { ...equipmentMapping };
    // console.log(equipmentMapping)
    delete newMapping[markerId];
    setEquipmentMapping(newMapping);
    // console.log(`Marker ${markerId} deleted`);
  };

  const handleMapEquipmentSave = () => {
    let locationMaps = [];
    if (equipmentMapping && markers) {
      markers.map((m)=>{
        const markerName = equipmentMapping[m.id]
        if (markerName) {
          const equipment = equipmentList.find(e => e.id == markerName.substring(markerName.lastIndexOf('-')+1));
          // const prevMapping = equipmentMappingList.find(e => e.mId == m.id);
          // const prevMapping = equipmentMappingList.find(e => e.equipment.id == equipment.id);
          // if (prevMapping) {
          //   locationMaps.push({id:prevMapping.id, equipment:{id:equipment.id},yawOrX:m.position.yaw, pitchOrY:m.position.pitch})
          // } else {
          //   locationMaps.push({equipment:{id:equipment.id},yawOrX:m.position.yaw, pitchOrY:m.position.pitch})
          // }
          locationMaps.push({equipment:{id:equipment.id},yawOrX:m.position.yaw, pitchOrY:m.position.pitch})
        }
      })

      const body = {
        // dto: {
        id : mapsId,
        coordinates : locationMaps
        // }
      }
      console.log(body)

      openModal(modals.confirmModal, {
          onSubmit : (value) => {
              // console.log('locationMaps write')
              patchEquipmentLocationMapCoordinates(body.id, body).then(()=>{
                  handleAlertClick(t('message.common.alert.save.done'));
                  setIsLoading(false);
              }).catch((err)=>{
                  console.log(err);
                  handleAlertClick(err.response?.data?.message || err.message);
              });
          },
          onClose : () => {
          },
          message: t('message.common.alert.save.question'),
      });
    }
  }

  return (
      <>
        {/* <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset",color:"#fff", marginRight:"4px", height: "37px" ,padding:"3px 10px"}} color="success">
          <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/view_in_ar.png`} alt='' /></span>&nbsp;VR
        </Button> */}
        <img
          src={fileUrl}
          alt="Thumbnail"
          // className="w-32 h-32 object-cover cursor-pointer rounded"
          onClick={handleOpen} 
          style={{width: "80px" ,height: "80px" ,padding:"3px", cursor:'pointer'}}
        />
  
        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard style={{maxWidth:"1440px", width:"90%", height:"81vh"}} title="" modal darkTitle content={false}>
            <CardContent style={{height:"100%"}}>
              <div className='pop_close'>
                <Button color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
  
              <div style={{width:"100%", height: '60vh'}}>
                <div ref={containerRef} style={{ width: '100%', height: '98%' }} />

                {modalOpen && (
                  <div style={{ position: 'fixed', top: '20%', left: '30%', width: '40%', padding: 20, background: 'white', color:'#000', border: '1px solid gray', zIndex: 1000 }}>
                    <h3>{t('message.common.title.equipment.mapping')}</h3>
                    <p>
                      <b>{t('message.common.subtitle.position')}:</b> yaw : {selectedCoords?.yaw.toFixed(4)}, pitch : {selectedCoords?.pitch.toFixed(4)} 
                      {equipmentMapping[selectedMarkerId] && <>, <b>{t('message.common.subtitle.equipment.name')}</b> : {equipmentMapping[selectedMarkerId].substring(0,equipmentMapping[selectedMarkerId].lastIndexOf('-'))}</>}
                    </p>

                    <div style={{display:'flex',justifyContent:'space-between', alignItems:'center', width:'100%'}}>
                      <div style={{witdh:'200px'}}>
                        <select onChange={(e) => handleMapEquipment(e.target.value)} defaultValue="">
                          <option value="" disabled>{t('message.common.select.equipment.select')}</option>
                          {getAvailableEquipments().map(e => (
                            <option key={e.id} value={e.id}>{e.name}</option>
                          ))}
                        </select>
                      </div>
                      <div style={{display:"flex", justifyContent: 'flex-end', alignItems:'center', gap:'16px', flex:'1'}}>
                        <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                          <button onClick={() => setModalOpen(false)} style={{padding:'5px', margin:'5px'}}>{t('message.common.btn.close')}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div style={{float:'right'}}>
                <Button variant="contained" color="primary" size="small" onClick={handleMapEquipmentSave}>
                  {t('message.common.btn.save')}
                </Button>
              </div>
              <div>
                * {t('message.common.guide.equipment.image.mapping.title')}<br/>
                1. {t('message.common.guide.equipment.image.mapping.step1')}<br/>
                2. {t('message.common.guide.equipment.image.mapping.step2')}<br/>
                3. {t('message.common.guide.equipment.image.mapping.step3')}<br/>
                4. {t('message.common.guide.equipment.image.mapping.step4')}<br/>
                5. {t('message.common.guide.equipment.image.mapping.step5')}
              </div>
            </CardContent>
  
          </MainCard>
        </Modal>

      </>
  )
}

export default CompanyPanoEquipmentMappingLayer;
  